import { z } from 'zod';

export const addressSchema = z.object({
  city: z.string().min(2, { message: 'Město musí být dlouhé aspoň 2 znaky' }),
  postCode: z
    .string()
    .min(5, { message: 'PSČ musí být dlouhé 5 znaků' })
    .max(5, { message: 'PSČ musí být dlouhé 5 znaků' }),
  street: z.string().min(2, { message: 'Ulice musí být dlouhá aspoň 2 znaky' }),
  descNum: z.number().min(1, { message: 'Číslo popisné musí být větší než 0' }),
  orientNum: z.number(),
});
